import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import Iam from "@app/types/Iam";

export const initializeApp = createAsyncAction(
  "@app/initialize/request",
  "@app/initialize/success",
  "@app/initialize/failure"
)<void, Iam, void>();

// Loads again everything that depends on the user's access, without reloading the page
export const reinitializeApp = createAsyncAction(
  "@app/reinitialize/request",
  "@app/reinitialize/success",
  "@app/reinitialize/failure"
)<void, Iam, unknown>();

export const fetchSandboxAccessToken = createAsyncAction(
  "@app/fetchSandboxAccessToken/request",
  "@app/fetchSandboxAccessToken/success",
  "@app/fetchSandboxAccessToken/failure"
)<{ callback?: (token: string, code?: string) => void }, string, void>();

export const fetchTokenHandoffCode = createAction("@app/fetchTokenHandoffCode")<{
  callback: (code: string) => void;
  failureCallback?: () => void;
}>();

export type Actions = ActionType<
  | typeof fetchSandboxAccessToken
  | typeof fetchTokenHandoffCode
  | typeof initializeApp
  | typeof reinitializeApp
>;
